import { paceStatusIcon } from "enums/paceStatus";
import { AssessmentCentreUser, UserAssessments } from "services/assessmentCentre";
import { RequestInfo } from "store/slice/store.types";
import { Pagination } from "types/global";
import { generateID } from "utils/utils";

export type ConvertedAssessmentCentre = {
    data: ConvertedAssessmentCentreUserData[];
    meta: Pagination;
    status: RequestInfo;
};

export type AssessmentCentrePaceStatus = keyof typeof paceStatusIcon;

export type ConvertedAssessmentCentreUserData = {
    id: number;
    userName: string;
    email: string;
    linkedinId: string | null;
    lastContactedOn: string | null;
    paceStatus: AssessmentCentrePaceStatus;
    assessments: UserAssessments[];
    teams: { id: number; name: string }[];
    checked: boolean;
    personId: number | null;
};

export const convertUserAssessmentList = (data: AssessmentCentreUser[]): ConvertedAssessmentCentreUserData[] => {
    return data.map((userData) => {
        const lastContactedString = userData.last_contacted_datetime?.toString();
        const lastContacted =
            typeof lastContactedString === "string" && !lastContactedString?.includes("Z")
                ? `${lastContactedString}Z`
                : lastContactedString;

        let paceStatus: AssessmentCentrePaceStatus = "Not Sharing";

        if (userData.optin_share_data) {
            paceStatus = userData.pace_status as AssessmentCentrePaceStatus;
        }

        return {
            id: userData.id,
            userName: userData.name,
            email: userData.email,
            linkedinId: userData.person.linkedin_id,
            lastContactedOn: lastContacted ?? null,
            paceStatus: paceStatus,
            assessments: userData.user_assessments,
            teams: userData.teams.map((team) => ({ ...team, id: generateID() })),
            checked: false,
            personId: userData.person.id,
        };
    });
};
